import React from 'react'
import styled from 'styled-components'
import performAction from '../actions'
import extractColor from '../helpers/extract-color'

Action = (props)->
	{icon, label, action, href, size, left, card, color, demo} = props
	href = href() if typeof href is 'function'

	handleAction = (e)->
		e.preventDefault() if demo
		performAction(action, card) if action and not demo
	
	<Button color={color} href={href} onClick={handleAction} target="_blank">
		<Icon size={size} leftoffset={left}>{icon}</Icon>
		<Label>{label}</Label>
	</Button>



Button = styled.a"""
	box-sizing: content-box
	position: relative
	display: block
	margin-top: 20px
	padding: 14px 22px;
	border: 2px solid;
	border-radius: 5
	text-align: center
	color: #141414
	cursor: pointer
	user-select: none
	border-color: #{({color})-> extractColor(color).color};
	
	&:first-child {
		margin-top: 0px
	}
	
	&:hover {
		padding: 16px 24px;
		color: white
		border: 0
		background: linear-gradient(#{({color})->
			{gradient, direction} = extractColor(color)
			return "#{direction}, #{gradient[0]}, #{gradient[1]}"
		});
	}
"""

Icon = styled.i"""
	position: absolute
	left: 16px
	top: 50%
	transform: translateY(-50%);
	font-size: #{({size})-> "#{size}px"}
	#{({leftoffset})-> if leftoffset then "margin-left: #{leftoffset}px"}
"""

Label = styled.span"""
	font-size: 14px
	font-weight: 500
	text-transform: uppercase
"""

export default Action